import { createApi } from '@core/fetch'

export default {
  //获取犀牛学院信息
  rhinoCollege: createApi('/hms/light/adminApi/merchantTask/rhinoCollege'),

  //详情信息
  details: createApi('/hms/light/adminApi/merchantTask/rhinoCollegeHomePage'),

  //
  connectUs: createApi('/p/wedding/index.php/Admin/APIMerchant/connectUs')
}
